import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FnButtonComponent } from './fn-button-component';
import { FnIconModule } from '../icons/index';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FnTranslateModule } from './../../i18n/index';

export * from './fn-button-component';

/** 
 * Exports the required FnButtonComponent to create button field
 * making them available for import by NgModules that import this module.
 */

@NgModule({
    imports: [FormsModule, CommonModule, FnIconModule, FnTranslateModule],
    exports: [FnButtonComponent],
    declarations: [FnButtonComponent],
    providers: [],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
})
export class FnButtonModule { }
